import { render, staticRenderFns } from "./OzonoForm.vue?vue&type=template&id=f500c208"
import script from "./OzonoForm.vue?vue&type=script&lang=js"
export * from "./OzonoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports